// extracted by mini-css-extract-plugin
export var noSpinners = "_s7-6";
export var percentageInput = "_s7-7";
export var variantColor1 = "_s7-0";
export var variantColor2 = "_s7-1";
export var variantColor3 = "_s7-2";
export var variantColor4 = "_s7-3";
export var variantColor5 = "_s7-4";
export var variantColor6 = "_s7-5";